export const getInfoCommand = "getInjectionInfo";
